import { EnvironmentTypeEnum } from '../app/models/types/environment-type';

export const environment = {
    version: '1.0.2-snapshot',
    type: EnvironmentTypeEnum.TEST,
    apiUrl: 'https://evidence-api-test.cloudflow.ro',
    coreUrl: 'https://core-api-test.cloudflow.ro/entity',
    usersUrl: 'https://users-api-test.cloudflow.ro/users-cloudflow',
    blockchainExplorerUrl: 'https://bc-explorer-test.cloudflow.ro/explorer/explorer',
    siteKey: '6LfAOSQoAAAAAMkhijlaYPrzWrInMjzLbu9GUJ9g',
    cloudFlow4TransUrl: 'https://app-test.cloudflow.ro/etransport',
    cloudFlow4InvoiceUrl: 'https://app-test.cloudflow.ro/einvoice'
};
